import { render } from "./school_sponsorised.vue?vue&type=template&id=7b453ff2&scoped=true"
import script from "./school_sponsorised.vue?vue&type=script&lang=js"
export * from "./school_sponsorised.vue?vue&type=script&lang=js"

import "./school_sponsorised.vue?vue&type=style&index=0&id=7b453ff2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b453ff2"]])

export default __exports__